import OfferDetailPage from "./OfferDetailPage.vue";

const vm = new Vue({
    el: '#mobile-offer-detail',
    name: 'MobileOfferDetail',
    components: {OfferDetailPage}
});
